module.exports = __webpack_public_path__ + "static/media/img.099d123d.jpg";